import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('api', 'fornecedor/integracao');

const fornecedorIntegracaoActions = {
  buscarFornecedorGemco: { method: 'GET', url: `${basePath}/buscar-fornecedor-gemco` },
};

export default (resource) => resource(`${basePath}`, {}, fornecedorIntegracaoActions);
